<template>
  <div class="pages">
    <div class="justify-start" style="margin:.2rem 0"  v-if="$store.state.userinfo.isSuper">
      <el-select clearable v-model="formInline.School" placeholder="请选择学校">
        <el-option
          v-for="item in schoolList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <el-row :gutter="26">
      <el-col :span="6" class="backimg">
        <div class="justify-center flex-col section total-section">
          <div class="flex-row items-start">
            <img src="@/assets/images/预约总数.png" class="image_1" />
            <div class="count">
              <span class="text_1">预约总数</span>
              <span class="text_2">{{ allCountStatic.allCount }}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="9" class="backimg">
        <div class="justify-between section judge-section">
          <div class="judge-state" v-for="(val, idx) in stateList" :key="idx">
            <div class="flex-row group_8 flex-row items-start">
              <img :src="val.icon" class="image_6" />
              <div class="count">
                <span class="text_9">{{ val.name }}</span>
                <span class="text_10" :class="idx == 2 ? 'error_text' : ''">{{
                  val.value
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="9" class="backimg">
        <div class="justify-between section judge-section">
          <div
            class="judge-state"
            v-for="(val, idx) in roomStateList"
            :key="idx"
          >
            <div class="flex-row group_8 flex-row items-start">
              <img :src="val.icon" class="image_8" />
              <div class="count">
                <span class="text_9">{{ val.name }}</span>
                <span class="text_10" :class="idx == 2 ? 'error_text' : ''">{{
                  val.value
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="register" :gutter="26">
      <el-col :span="6">
        <el-card class="box-card user-card">
          <span class="title">今日预约数据概览</span>
          <div id="userNumber" style="width: 100%; height: 2.93rem"></div>
        </el-card>
        <el-card class="box-card user-card" style="margin-top: .2rem;">
          <span class="title">今日返校数据概览</span>
          <div id="userRole" style="width: 100%; height: 2.93rem"></div>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-card class="box-card">
          <span class="title">预约返校数据趋势</span>
          <el-tabs
            class="mini tabsRight"
            v-model="authentication"
            @tab-click="handleClick2"
          >
            <el-tab-pane label="近一周" :name="0"></el-tab-pane>
            <el-tab-pane label="近一月" :name="1"></el-tab-pane>
            <el-tab-pane label="近三个月" :name="2"></el-tab-pane>
          </el-tabs>
          <div class="justify-end" style="margin-top:20px">
            <el-date-picker
              v-model="dateValue_0"
              @change="dateChange_0"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
          <div id="rz" style="width: 90%; margin:auto; height: 5.85rem"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0.25rem">
      <el-card class="box-card">
        <el-tabs v-model="activeName" @tab-click="handleTabsClick">
          <el-tab-pane label="校友返校综合统计" name="first">
            <div v-if="activeName == 'first'">
              <div class="justify-end">
                <el-date-picker
                  v-model="dateValue"
                  @change="dateChange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
              <div class="collegeStuStatistic">
                <span class="title">各学院校友返校统计</span>
                <div id="time" style="width: 100%; height: 4.1rem"></div>
              </div>
              <div class="collegeStatisticList">
                <div class="rankStatisticItem">
                  <span class="title">返校校友行业统计</span>
                  <el-table
                    class="rank-table"
                    :data="backWorkRankData"
                    style="width: 100%"
                  >
                    <el-table-column align="center" prop="date" label="排名">
                      <template v-slot="{ row, $index }">
                        <div
                          class="rank-icon"
                          :class="
                            $index == 0
                              ? 'first'
                              : $index == 1
                              ? 'second'
                              : $index == 2
                              ? 'third'
                              : ''
                          "
                        >
                          {{ $index + 1 }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="key" label="行业">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="count"
                      label="返校人数"
                    >
                    </el-table-column>
                  </el-table>
                </div>
                <div class="rankStatisticItem">
                  <span class="title">返校校友届数排行</span>
                  <el-table
                    class="rank-table"
                    :data="backYearRankData"
                    style="width: 100%"
                  >
                    <el-table-column align="center" prop="date" label="排名">
                      <template v-slot="{ row, $index }">
                        <div
                          class="rank-icon"
                          :class="
                            $index == 0
                              ? 'first'
                              : $index == 1
                              ? 'second'
                              : $index == 2
                              ? 'third'
                              : ''
                          "
                        >
                          {{ $index + 1 }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="key" label="届数">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="count"
                      label="返校人数"
                    >
                    </el-table-column>
                  </el-table>
                </div>
                <div class="rankStatisticItem">
                  <span class="title">返校校友男女比例</span>
                  <div id="userAge" style="width: 100%; height: 2.6rem"></div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="校友预约综合统计" name="second">
            <div v-if="activeName == 'second'">
              <div class="justify-end">
                <el-date-picker
                  v-model="dateValue"
                  @change="dateChange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
              <div class="collegeStuStatistic">
                <span class="title">各学院校友预约统计</span>
                <div id="time" style="width: 100%; height: 4.1rem"></div>
              </div>
              <div class="collegeStatisticList">
                <div class="rankStatisticItem">
                  <span class="title">预约校友行业统计</span>
                  <el-table
                    class="rank-table"
                    :data="backWorkRankData"
                    style="width: 100%"
                  >
                    <el-table-column align="center" prop="date" label="排名">
                      <template v-slot="{ row, $index }">
                        <div
                          class="rank-icon"
                          :class="
                            $index == 0
                              ? 'first'
                              : $index == 1
                              ? 'second'
                              : $index == 2
                              ? 'third'
                              : ''
                          "
                        >
                          {{ $index + 1 }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="key" label="行业">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="count"
                      label="预约人数"
                    >
                    </el-table-column>
                  </el-table>
                </div>
                <div class="rankStatisticItem">
                  <span class="title">预约校友届数排行</span>
                  <el-table
                    class="rank-table"
                    :data="backYearRankData"
                    style="width: 100%"
                  >
                    <el-table-column align="center" prop="date" label="排名">
                      <template v-slot="{ row, $index }">
                        <div
                          class="rank-icon"
                          :class="
                            $index == 0
                              ? 'first'
                              : $index == 1
                              ? 'second'
                              : $index == 2
                              ? 'third'
                              : ''
                          "
                        >
                          {{ $index + 1 }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="key" label="届数">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="count"
                      label="预约人数'"
                    >
                    </el-table-column>
                  </el-table>
                </div>
                <div class="rankStatisticItem">
                  <span class="title">预约校友男女比例</span>
                  <div id="userAge" style="width: 100%; height: 2.6rem"></div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-row>
  </div>
</template>
<script>
import {
  staticEchartsInit,
  useEchartsInit,
  userEchartsInit,
  userEchartsInit2,
  userEchartsInit3,
  userEchartsInit4,
  publishEchartsInit
} from "./echartsInit.js";
import {
  ReturnSchoolPrebookCountApi,
  PrebookTodeyApi,
  ReturnSchoolTodeyApi,
  ReturnSchoolPrebookTrendApi,
  ReturnSchoolByCollegeApi,
  ReturnSchoolByWorkFieldApi,
  ReturnSchoolByYearApi,
  ReturnSchoolByGenderApi,
  PrebookByCollegeApi,
  PrebookByYearApi,
  PrebookByWorkFieldApi,
  PrebookByGenderApi
} from "@/request/requestApi.js";

export default {
  data() {
    return {
      schoolList: [],
      formInline: { School: "" },
      dateValue_0: [],
      dateValue: [],
      activeName: "first",
      value: 100,
      maxValue: 0,
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普"
        }
      ],
      stateList: [
        {
          icon: require("@/assets/images/待审核.png"),
          name: "待审核",
          value: 0
        },
        {
          icon: require("@/assets/images/已同意.png"),
          name: "已同意",
          value: 0
        },
        {
          icon: require("@/assets/images/已驳回.png"),
          name: "已驳回",
          value: 0
        }
      ],
      roomStateList: [
        {
          icon: require("@/assets/images/待返校.png"),
          name: "待返校",
          value: 0
        },
        {
          icon: require("@/assets/images/已返校.png"),
          name: "已返校",
          value: 0
        },
        {
          icon: require("@/assets/images/未返校.png"),
          name: "未返校",
          value: 0
        }
      ],
      // 首页top循环
      dataList: [
        {
          name: "新增用户数",
          number: "",
          state: true
        },
        {
          name: "日活用户量",
          number: "",
          state: false
        },
        {
          name: "新增内容量",
          number: "",
          state: true
        },
        {
          name: "意见反馈量",
          number: "",
          state: false
        }
      ],
      register: "1", //注册量tabs
      registerTime: [], //注册量时间
      authentication: 0, //认证统计tabs
      useTime: 0, //平均使用时间tabs
      workList: [
        { name: "在校生", value: 343 },
        { name: "计算机/互联网/通信/电子", value: 153 },
        { name: "销售/客服", value: 563 },
        { name: "会计/金融/银行/保险", value: 253 },
        { name: "生产/营运/采购/物流", value: 843 },
        { name: "人事/行政/高级管理", value: 535 },
        { name: "建筑/房地产", value: 32 },
        { name: "教育/培训", value: 456 },
        { name: "设计/市场/媒体/广告", value: 459 },
        { name: "生物/制药/化工/医疗", value: 138 },
        { name: "咨询/法律/科研", value: 354 },
        { name: "服务业", value: 52 },
        { name: "政府机构/翻译/其他", value: 552 }
      ],
      //新增新户信息
      addUserInfo: {},
      //日活用户了
      dayActiveInfo: {},
      //新增内容量
      dataAddArticle: {},
      //意见反馈
      dataFeedback: {},
      //认证统计
      dataAttestation: {},
      //统计图表
      staticEchartValue: [],
      //未认证
      staticEchartValue2: [],
      staticEchartName: [],
      //使用图表
      useEchartValue: [],
      useEchartName: [],
      //使用时长
      useTimeData: [],
      //用户角色统计
      attestationUserCount: {},
      //工作领域统计
      homeDataWorkFieldCount: {},
      //用户年龄统计
      homeDataAgeCount: {},
      //周活跃统计
      homeDataWeekActive: {},
      //内容发布
      homeDataArticleCount: {},
      homeDataArticleName: [],
      homeDataArticleValue: [],
      allCountStatic: {
        allCount: 0,
        waitAuditCount: 0,
        passCount: 0,
        noPassCount: 0,
        waitReturnSchoolCount: 0,
        returnSchoolCount: 0,
        noReturnSchoolCount: 0
      },
      backWorkRankData: [],
      backYearRankData: []
    };
  },
  watch: {
    "formInline.School": function(newVal, oldVal) {
      this.getReturnSchoolPrebookCount();
      this.getPrebookTodey();
      this.getReturnSchoolTodey();
      this.getReturnSchoolPrebookTrend();
      if (this.activeName == "first") {
        this.getReturnSchoolByCollege();
        this.getReturnSchoolByWorkField();
        this.getReturnSchoolByYear();
        this.getReturnSchoolByGender();
      } else {
        this.getPrebookByCollege();
        this.getPrebookByYear();
        this.getPrebookByWorkField();
        this.getPrebookByGender();
      }
    }
  },

  async created() {
    this.getHomeDataAddUser(1);
    this.getHomeDataDayActive();
    this.getDataAddArticle();
    this.getHomeDataFeedback();
    // this.getHomeDataAttestation(); // 预约返校统一调 getReturnSchoolPrebookTrend
    this.getHomeDataDayUseTime();
    this.getHomeDataAttestationUserCount();
    this.getHomeDataAgeCount();
    this.getHomeDataWorkFieldCount();
    this.getHomeDataWeekActive();
    this.getHomeDataArticleCount();
    this.getReturnSchoolPrebookCount();
    this.getPrebookTodey();
    this.getReturnSchoolTodey();
    this.getReturnSchoolPrebookTrend();
    this.getReturnSchoolByCollege();
    this.getReturnSchoolByWorkField();
    this.getReturnSchoolByYear();
    this.getReturnSchoolByGender();
    this.getSchoolList();
  },
  methods: {
    //获取学校
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    async dateChange_0(val) {
      this.getReturnSchoolPrebookTrend();
    },
    async dateChange(val) {
      if (this.activeName == "first") {
        this.getReturnSchoolByCollege();
        this.getReturnSchoolByWorkField();
        this.getReturnSchoolByYear();
        this.getReturnSchoolByGender();
      } else {
        this.getPrebookByCollege();
        this.getPrebookByYear();
        this.getPrebookByWorkField();
        this.getPrebookByGender();
      }
    },
    async handleTabsClick(tab, event) {
      this.dateValue = [];
      if (this.activeName == "first") {
        this.getReturnSchoolByCollege();
        this.getReturnSchoolByWorkField();
        this.getReturnSchoolByYear();
        this.getReturnSchoolByGender();
      } else {
        this.getPrebookByCollege();
        this.getPrebookByYear();
        this.getPrebookByWorkField();
        this.getPrebookByGender();
      }
    },
    handleClick() {
      this.registerTime = [];
      this.getHomeDataAddUser();
    },
    handleClick2() {
      // this.getHomeDataAttestation();
      this.getReturnSchoolPrebookTrend();
    },
    // dateChange() {
    //   this.register = 0;
    //   this.getHomeDataAddUser();
    // },
    //获取首页用户新增
    getHomeDataAddUser() {
      var query = {
        type: this.register,
        starttime: this.registerTime == null ? "" : this.registerTime[0],
        endtime: this.registerTime == null ? "" : this.registerTime[1]
      };
      var url = this.$dataConver.getUrl(
        "/admin/Home/GetHomeDataAddUser",
        query
      );
      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.addUserInfo = res.data;
          if (this.register == 1) {
            this.dataList[0].number = this.addUserInfo.userCount;
            this.dataList[0].state = this.addUserInfo.isUp;
          }
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取首页用户新增
    getHomeDataDayActive() {
      this.$api.get("/admin/Home/GetHomeDataDayActive").then(res => {
        if (res.succeed) {
          this.dayActiveInfo = res.data;
          this.dataList[1].number = this.dayActiveInfo.activeCount;
          this.dataList[1].state = this.dayActiveInfo.isUp;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取首页用户新增
    getDataAddArticle() {
      this.$api.get("/admin/Home/GetHomeDataAddArticle").then(res => {
        if (res.succeed) {
          this.dataAddArticle = res.data;
          this.dataList[2].number = this.dataAddArticle.articleCount;
          this.dataList[2].state = this.dataAddArticle.isUp;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取首页意见反馈
    getHomeDataFeedback() {
      this.$api.get("/admin/Home/GetHomeDataFeedback").then(res => {
        if (res.succeed) {
          this.dataFeedback = res.data;
          this.dataList[3].number = this.dataFeedback.feedbackCount;
          this.dataList[3].state = this.dataFeedback.isUp;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取认证统计
    getHomeDataAttestation() {
      var query = {
        type: this.authentication
      };
      var url = this.$dataConver.getUrl(
        "/admin/Home/GetHomeDataAttestation",
        query
      );
      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.staticEchartValue = [];
          this.staticEchartValue2 = [];
          this.staticEchartName = [];
          this.dataAttestation = res.data;
          console.log(this.dataAttestation);
          this.dataAttestation.attestation.forEach(element => {
            this.staticEchartValue.push(element.value);
            this.staticEchartName.push(element.name);
          });
          this.dataAttestation.noAttestation.forEach(element => {
            this.staticEchartValue2.push(element.value);
          });

          setTimeout(() => {
            console.log(this.staticEchartName);
            console.log(this.staticEchartValue);
            console.log(this.staticEchartValue2);
            staticEchartsInit(
              this.staticEchartName,
              this.staticEchartValue,
              this.staticEchartValue2
            );
          }, 20);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取评价使用时长
    getHomeDataDayUseTime() {
      var query = {
        type: this.authentication
      };
      var url = this.$dataConver.getUrl(
        "/admin/Home/GetHomeDataDayUseTime",
        query
      );
      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.useEchartValue = [];
          this.useEchartName = [];
          this.useTimeData = res.data;
          this.useTimeData.forEach(element => {
            this.useEchartValue.push(element.value);
            this.useEchartName.push(element.name);
          });
          setTimeout(() => {
            console.log(this.useEchartName);
            console.log(this.useEchartValue);
            // useEchartsInit(this.useEchartName, this.useEchartValue);
          }, 20);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取角色统计
    getHomeDataAttestationUserCount() {
      this.$api.get("/admin/Home/GetHomeDataAttestationUserCount").then(res => {
        if (res.succeed) {
          this.attestationUserCount = res.data;
          console.log(this.attestationUserCount);
          // userEchartsInit(this.attestationUserCount.attestation);
          // userEchartsInit2(this.attestationUserCount.attestationRole);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取工作领域
    getHomeDataWorkFieldCount() {
      this.$api.get("/admin/Home/GetHomeDataWorkFieldCount").then(res => {
        if (res.succeed) {
          this.homeDataWorkFieldCount = res.data;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取用户年龄统计
    getHomeDataAgeCount() {
      this.$api.get("/admin/Home/GetHomeDataAgeCount").then(res => {
        if (res.succeed) {
          this.homeDataAgeCount = res.data;
          // console.log('---------------------',this.homeDataAgeCount)
          // userEchartsInit3(this.homeDataAgeCount);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取周活跃统计
    getHomeDataWeekActive() {
      this.$api.get("/admin/Home/GetHomeDataWeekActive").then(res => {
        if (res.succeed) {
          this.homeDataWeekActive = res.data;
          userEchartsInit4(this.homeDataWeekActive);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取内容发布量
    getHomeDataArticleCount() {
      this.$api.get("/admin/Home/GetHomeDataArticleCount").then(res => {
        if (res.succeed) {
          this.homeDataArticleName = [];
          this.homeDataArticleValue = [];
          this.homeDataArticleCount = res.data;
          this.homeDataArticleCount.forEach(element => {
            this.homeDataArticleName.push(element.name);
            this.homeDataArticleValue.push(element.value);
          });
          publishEchartsInit(
            this.homeDataArticleName,
            this.homeDataArticleValue
          );
        } else {
          this.$message.error(res.error);
        }
      });
    },
    async getReturnSchoolPrebookCount() {
      let params = {
        School: this.formInline.School ? this.formInline.School : null
      };
      let res = await ReturnSchoolPrebookCountApi(params);
      if (res.succeed) {
        this.allCountStatic.allCount = res.data.allCount;
        this.allCountStatic.waitAuditCount = res.data.waitAuditCount;
        this.stateList[0].value = res.data.waitAuditCount;
        this.allCountStatic.passCount = res.data.passCount;
        this.stateList[1].value = res.data.passCount;
        this.allCountStatic.noPassCount = res.data.noPassCount;
        this.stateList[2].value = res.data.noPassCount;
        this.allCountStatic.waitReturnSchoolCount =
          res.data.waitReturnSchoolCount;
        this.roomStateList[0].value = res.data.waitReturnSchoolCount;
        this.allCountStatic.returnSchoolCount = res.data.returnSchoolCount;
        this.roomStateList[1].value = res.data.returnSchoolCount;
        this.allCountStatic.noReturnSchoolCount = res.data.noReturnSchoolCount;
        this.roomStateList[2].value = res.data.noReturnSchoolCount;
      }
    },
    async getPrebookTodey() {
      let params = {
        School: this.formInline.School ? this.formInline.School : null
      };
      let res = await PrebookTodeyApi(params);
      if (res.succeed) {
        userEchartsInit([
          {
            name: "待审核",
            value: res.data.waitAuditCount
          },
          {
            name: "已同意",
            value: res.data.passCount
          },
          {
            name: "已驳回",
            value: res.data.noPassCount
          }
        ]);
      }
    },
    async getReturnSchoolTodey() {
      let params = {
        School: this.formInline.School ? this.formInline.School : null
      };
      let res = await ReturnSchoolTodeyApi(params);
      if (res.succeed) {
        userEchartsInit2([
          {
            name: "已返校",
            value: res.data.returnSchoolCount
          },
          {
            name: "未返校",
            value: res.data.noReturnSchoolCount
          }
        ]);
      }
    },
    async getReturnSchoolPrebookTrend() {
      const params = {
        School: this.formInline.School ? this.formInline.School : null,

        StartTime:
          this.dateValue_0 && this.dateValue_0[0] ? this.dateValue_0[0] : null,
        EndTime:
          this.dateValue_0 && this.dateValue_0[1] ? this.dateValue_0[1] : null,
        DateTimeEnum:
          this.dateValue_0 && this.dateValue_0[0] && this.dateValue_0[1]
            ? null
            : this.authentication
      };
      let res = await ReturnSchoolPrebookTrendApi(params);
      if (res.succeed) {
        let staticEchartName = [];
        let staticEchartValue = [];
        let staticEchartValue2 = [];
        res.data.forEach(item => {
          staticEchartName.push(item.time);
          staticEchartValue.push(item.returnSchoolCount);
          staticEchartValue2.push(item.prebookCount);
        });
        setTimeout(() => {
          staticEchartsInit(
            staticEchartName,
            staticEchartValue,
            staticEchartValue2
          );
        }, 20);
      }
    },
    async getReturnSchoolByCollege() {
      const params = {
        School: this.formInline.School ? this.formInline.School : null,

        StartTime:
          this.dateValue && this.dateValue[0] ? this.dateValue[0] : null,
        EndTime: this.dateValue && this.dateValue[1] ? this.dateValue[1] : null
      };
      let res = await ReturnSchoolByCollegeApi(params);
      if (res.succeed) {
        let useEchartName = [];
        let useEchartValue = [];
        res.data.forEach(item => {
          useEchartName.push(item.key);
          useEchartValue.push(item.count);
        });
        setTimeout(() => {
          useEchartsInit(useEchartName, useEchartValue);
        }, 20);
      }
    },
    async getReturnSchoolByWorkField() {
      const params = {
        School: this.formInline.School ? this.formInline.School : null,

        StartTime:
          this.dateValue && this.dateValue[0] ? this.dateValue[0] : null,
        EndTime: this.dateValue && this.dateValue[1] ? this.dateValue[1] : null
      };
      let res = await ReturnSchoolByWorkFieldApi(params);
      if (res.succeed) {
        this.backWorkRankData = res.data;
      }
    },
    async getReturnSchoolByYear() {
      const params = {
        School: this.formInline.School ? this.formInline.School : null,

        StartTime:
          this.dateValue && this.dateValue[0] ? this.dateValue[0] : null,
        EndTime: this.dateValue && this.dateValue[1] ? this.dateValue[1] : null
      };
      let res = await ReturnSchoolByYearApi(params);
      if (res.succeed) {
        this.backYearRankData = res.data;
      }
    },
    async getReturnSchoolByGender() {
      const params = {
        School: this.formInline.School ? this.formInline.School : null,

        StartTime:
          this.dateValue && this.dateValue[0] ? this.dateValue[0] : null,
        EndTime: this.dateValue && this.dateValue[1] ? this.dateValue[1] : null
      };
      let res = await ReturnSchoolByGenderApi(params);
      if (res.succeed) {
        let staticData = [
          {
            name: "女",
            value: res.data.womenCount
          },
          {
            name: "男",
            value: res.data.menCount
          }
        ];
        userEchartsInit3(staticData, 0);
      }
    },

    async getPrebookByCollege() {
      const params = {
        School: this.formInline.School ? this.formInline.School : null,

        StartTime:
          this.dateValue && this.dateValue[0] ? this.dateValue[0] : null,
        EndTime: this.dateValue && this.dateValue[1] ? this.dateValue[1] : null
      };
      let res = await PrebookByCollegeApi(params);
      if (res.succeed) {
        let useEchartName = [];
        let useEchartValue = [];
        res.data.forEach(item => {
          useEchartName.push(item.key);
          useEchartValue.push(item.count);
        });
        setTimeout(() => {
          useEchartsInit(useEchartName, useEchartValue);
        }, 20);
      }
    },
    async getPrebookByYear() {
      const params = {
        School: this.formInline.School ? this.formInline.School : null,

        StartTime:
          this.dateValue && this.dateValue[0] ? this.dateValue[0] : null,
        EndTime: this.dateValue && this.dateValue[1] ? this.dateValue[1] : null
      };
      let res = await PrebookByYearApi(params);
      if (res.succeed) {
        this.backYearRankData = res.data;
      }
    },
    async getPrebookByWorkField() {
      const params = {
        School: this.formInline.School ? this.formInline.School : null,

        StartTime:
          this.dateValue && this.dateValue[0] ? this.dateValue[0] : null,
        EndTime: this.dateValue && this.dateValue[1] ? this.dateValue[1] : null
      };
      let res = await PrebookByWorkFieldApi(params);
      if (res.succeed) {
        this.backWorkRankData = res.data;
      }
    },
    async getPrebookByGender() {
      const params = {
        School: this.formInline.School ? this.formInline.School : null,
        StartTime:
          this.dateValue && this.dateValue[0] ? this.dateValue[0] : null,
        EndTime: this.dateValue && this.dateValue[1] ? this.dateValue[1] : null
      };
      let res = await PrebookByGenderApi(params);
      if (res.succeed) {
        let staticData = [
          {
            name: "女",
            value: res.data.womenCount
          },
          {
            name: "男",
            value: res.data.menCount
          }
        ];
        userEchartsInit3(staticData, 1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.iconTitle {
  display: inline-block;
  width: 0.45rem;
  text-align: right;
  font-size: 0.16rem;
  color: #333;
}
.user-card >>> .el-card__body {
  // padding-bottom: 36px !important;
}
.registerFlex {
  display: flex;
  align-items: center;
}
.userCount {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.register {
  .data {
    padding: 0.2rem 0;
    .avaImg {
      width: 0.82rem;
      height: 0.82rem;
    }
    span {
      color: #333333;
      font-size: 0.16rem;
      display: inline-block;
      // min-width: 0.3rem;
      white-space: nowrap;
    }
    b {
      color: #333333;
      font-size: 0.6rem;
    }
    img {
      // width: 0.21rem;
      // height: 0.32rem;
      vertical-align: middle;
    }
    .number {
      color: #2e9bff;
      font-size: 0.24rem;
    }
    .number2 {
      margin-left: 0.07rem;
      margin-top: 0.14rem;
      color: #2e9bff;
      font-size: 0.3rem;
    }
    div:nth-child(2) {
      .number,
      .number2 {
        color: #fb8994;
      }
    }
  }
}
.collegeStuStatistic {
  margin-top: 0.2rem;
  width: 100%;
  padding: 0.2rem;
  border-radius: 10px;
  border: 1px solid #d7dbf9;
}
.collegeStatisticList {
  margin-top: 0.2rem;
  display: flex;
  justify-content: space-between;
  .rankStatisticItem {
    width: 32%;
    padding: 0.2rem;
    border-radius: 10px;
    border: 1px solid #d7dbf9;
    .rank-table {
      margin-top: 0.2rem;
    }
    >>> .el-table__row--striped .el-table__cell {
      background-color: #d7dbf950 !important; /* 设置斑马纹背景色 */
    }
    .rank-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto;
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 50%;
      font-weight: 400;
      font-size: 14px;
    }
    .first {
      background: #df5b5a;
      color: #ffffff;
    }
    .second {
      background: #e2751b;
      color: #ffffff;
    }
    .third {
      background: #efc12d;
      color: #ffffff;
    }
  }
}
.section {
  border-radius: 0.1rem;
  .image_1 {
    margin-top: -0.05rem;
    flex-shrink: 0;
    width: 0.5rem;
    height: 0.5rem;
    object-fit: contain;
  }
  .text_1 {
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
  }
  .image_6 {
    flex-shrink: 0;
    width: 0.21rem;
    height: 0.32rem;
  }
  .image_8 {
    margin-top: -0.12rem;
    flex-shrink: 0;
    width: 0.46rem;
    height: 0.46rem;
    object-fit: contain;
  }
}

.total-section {
  padding: 0.3rem 0rem 0.2rem 0.3rem;
  background: #5f79f9;
  .count {
    margin-left: 0.25rem;
    display: flex;
    flex-direction: column;
    align-items: start;
    .text_2 {
      margin-top: 0.22rem;
      line-height: 1;
      font-weight: bold;
      font-size: 36px;
      color: #ffffff;
    }
  }
}
.judge-section {
  padding: 0.3rem 0.85rem 0.2rem 0.3rem;
  background: #ffffff;
  border-radius: 10px;
  .count {
    margin-left: 0.25rem;
    display: flex;
    flex-direction: column;
    align-items: start;
    .text_9 {
      font-weight: 400;
      font-size: 16px;
      color: #666666;
    }
    .text_10 {
      margin-top: 36px;
      line-height: 1;
      font-weight: bold;
      font-size: 24px;
      color: #333333;
    }
  }
}
.error_text {
  color: #e0647d !important;
}
.back0 {
  background-image: linear-gradient(
    135deg,
    rgb(255, 139, 135) 0%,
    rgb(247, 192, 149) 100%
  );
}
.back1 {
  background-image: linear-gradient(
    135deg,
    rgb(66, 220, 197) 0%,
    rgb(9, 195, 159) 100%
  );
}
.back2 {
  background-image: linear-gradient(
    135deg,
    rgb(52, 214, 255) 0%,
    rgb(53, 158, 252) 100%
  );
}
.back3 {
  background-image: linear-gradient(
    135deg,
    rgb(74, 165, 253) 0%,
    rgb(73, 112, 254) 100%
  );
}

.backimg0 {
  background-image: url("../../../assets/images/backimg0.png");
}
.backimg1 {
  background-image: url("../../../assets/images/backimg1.png");
}
.backimg2 {
  background-image: url("../../../assets/images/backimg2.png");
}
.backimg3 {
  background-image: url("../../../assets/images/backimg3.png");
}
.backimg {
  background-repeat: no-repeat;
  padding-bottom: 0.2rem;
  background-size: 90% 100%;
  background-position: bottom;
}
>>> {
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-date-editor--timerange.el-input__inner {
    width: 100%;
  }
}
.work {
  width: 75%;
  margin: 0.092rem auto 0;
  span {
    font-size: 14px;
    color: #282828;
  }
}
.workList {
  .work:nth-child(1) >>> .el-slider__bar {
    background: #ff5757;
  }
  .work:nth-child(2) >>> .el-slider__bar {
    background: #ff7723;
  }
  .work:nth-child(3) >>> .el-slider__bar {
    background: #eade20;
  }
  .work:nth-child(4) >>> .el-slider__bar {
    background: #b8da88;
  }
  .work:nth-child(5) >>> .el-slider__bar {
    background: #15b062;
  }
  .work:nth-child(6) >>> .el-slider__bar {
    background: #4ea7ec;
  }
  .work:nth-child(7) >>> .el-slider__bar {
    background: #32169a;
  }
  .work:nth-child(8) >>> .el-slider__bar {
    background: #b316c0;
  }
  .work:nth-child(9) >>> .el-slider__bar {
    background: #ec4887;
  }
  .work:nth-child(10) >>> .el-slider__bar {
    background: #2f3a4c;
  }
  .work:nth-child(11) >>> .el-slider__bar {
    background: #f1d59a;
  }
  .work:nth-child(12) >>> .el-slider__bar {
    background: #4ea7ec;
  }
  .work:nth-child(13) >>> .el-slider__bar {
    background: #dbb3d5;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/backSchool/backSchoolStatistic/index.vue